import { Button, Card, Checkbox, CheckboxChangeEvent, Grid, Image } from "antd";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import defaultImage from "../../../../assets/images/content/empty_session.webp";
import CaretDown from "../../../../assets/images/icons/CaretDown";
import Trash from "../../../../assets/images/icons/Trash";
import { P1 } from "../../../../components/NormalFonts";
import { useGetSkiResort } from "../../../../hooks/Resorts/resort.hooks";
import {
  SearchResponse,
  SearchSessionDetail,
} from "../../../../hooks/Search/data";
import useGetTimezone from "../../../../hooks/Timezone/timezone.hooks";
import { moneyFormat } from "../../../../plugins/numberFormat";
import { SessionItem } from "../../../Result/components/SearchResult/components";
import { CartItemProps } from "./data";
import styles from "./styles.module.scss";

const CartItem: React.FC<CartItemProps> = ({
  item,
  index,
  handleCheckBoxChange,
  handleDeleteCart,
}) => {
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { t } = useTranslation();
  const { formatDate, toLocalTimezone } = useGetTimezone();
  const [openDetail, setOpenDetail] = useState<boolean>(false);

  const { data: resortList } = useGetSkiResort({});

  const renderDate = (sessions: SearchSessionDetail[]) => {
    if (sessions.length <= 1) {
      return formatDate(toLocalTimezone(sessions[0].date));
    }
    return `${formatDate(
      toLocalTimezone(sessions[0].date)
    )} - ${toLocalTimezone(sessions[sessions.length - 1].date)?.format(
      `MM${t("format.date.month")}DD${t("format.date.date")}`
    )}`;
  };

  const handleOpenDetail = () => {
    setOpenDetail((prev) => !prev);
  };

  const renderSession = (order: SearchResponse) => {
    return order.session_details.map(
      (_session: SearchSessionDetail, index: number) => {
        return (
          <SessionItem
            data={_session}
            key={`session_${index}`}
            nickname={item?.coach_nickname}
            adults={order.adults}
            kids={order.kids}
          />
        );
      }
    );
  };

  return (
    <Card
      style={{ width: "100%" }}
      styles={{ body: { padding: screens.sm ? "12px 24px" : "12px" } }}
      variant={"borderless"}
    >
      <div
        className={`${styles.titleContainer} ${
          screens.sm ? "" : styles.mobile
        } ${item.cart_status ? "" : styles.disable}`}
      >
        <div className={styles.leftWrapper}>
          <div className={styles.checkboxWrapper}>
            <Checkbox
              checked={item.checked}
              onChange={(e: CheckboxChangeEvent) =>
                handleCheckBoxChange(e, index, item)
              }
              disabled={!item.cart_status}
            />
            <div className={styles.buttonMobileContainer}>
              <Button
                onClick={() => handleDeleteCart(item)}
                size="small"
                type="link"
                icon={
                  <Trash style={{ color: "var(--secondary)", fontSize: 24 }} />
                }
              />
              <Button
                onClick={handleOpenDetail}
                size="small"
                type="link"
                iconPosition={"end"}
                disabled={!item.cart_status}
                style={{ paddingRight: 0 }}
                icon={
                  <CaretDown
                    style={{ color: "var(--primary)", fontSize: 18 }}
                    className={`${styles.arrow} ${
                      openDetail ? styles.open : ""
                    }`}
                  />
                }
              >
                {t("record.detail")}
              </Button>
            </div>
          </div>
          <div className={styles.imageAndContent}>
            <Image
              preview={false}
              src={
                resortList?.find(
                  (resort) =>
                    resort.ski_resort_code ===
                    item.session_details[0].ski_resort_code
                )?.image_url
              }
              width={84}
              height={84}
              style={{ objectFit: "cover", borderRadius: 8 }}
              fallback={defaultImage}
            />
            <div className={styles.contentWrapper}>
              <P1 weight="medium" color="var(--text-content-1)">
                {
                  item?.coach_nickname
                    ? t("normal.coach.nickname", {
                        nickname: item.coach_nickname,
                      })
                    : renderDate(item.session_details)
                  // t(`skiresort.${item.ski_resort_code}`)
                }
              </P1>
              <P1 color="var(--text-content-1)">
                {item?.coach_nickname ? renderDate(item.session_details) : null}
              </P1>

              <P1 color="var(--text-content-1)">
                {t(`skiresort.${item.ski_resort_code}`)}
              </P1>

              <P1 color="var(--text-content-1)">
                {t(`checkout.lessons`, {
                  skill: t(`normal.skill.${item.skill_code}`),
                  count: item.session_details.length,
                })}
              </P1>
            </div>
          </div>
        </div>
        <div className={styles.rightWrapper}>
          <div className={styles.buttonContainer}>
            <Button
              onClick={() => handleDeleteCart(item)}
              size="small"
              type="link"
              icon={
                <Trash style={{ color: "var(--secondary)", fontSize: 24 }} />
              }
            />
            <Button
              onClick={handleOpenDetail}
              size="small"
              type="link"
              iconPosition={"end"}
              disabled={!item.cart_status}
              icon={
                <CaretDown
                  style={{ color: "var(--primary)", fontSize: 18 }}
                  className={`${styles.arrow} ${openDetail ? styles.open : ""}`}
                />
              }
            >
              {t("record.detail")}
            </Button>
          </div>
          <P1
            className={styles.total}
            weight="heavy"
            color="var(--primary)"
          >{`${t(`currency.${process.env.REACT_APP_CURRENCY}`)}${moneyFormat(
            item.total_price
          )}`}</P1>
        </div>
      </div>
      {openDetail ? (
        <div
          className={`${styles.sessionContainer} ${
            styles.sm ? "" : styles.mobile
          }`}
        >
          {renderSession(item)}
        </div>
      ) : null}
    </Card>
  );
};

export default CartItem;
